import { render } from "./TvmStructuredSuggestions.vue?vue&type=template&id=5d52d7da&scoped=true"
import script from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"
export * from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"

import "./TvmStructuredSuggestions.vue?vue&type=style&index=0&id=5d52d7da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d52d7da"]])

export default __exports__